import { gql, DocumentNode } from '@apollo/client';

export interface GetSubjectStatsQueryVariables {
  courseId: string;
  subjectId: string;
}

export interface GetSubjectStatsQueryResult<TSubjectStats> {
  subject: TSubjectStats;
}

export const getSubjectStatsQuery = (fragment: DocumentNode) => gql`
  query GetSubjectStatsQuery($courseId: String, $subjectId: String) {
    subject(courseId: $courseId, subjectId: $subjectId)
      @rest(type: "SubjectWithStats", path: "courses/{args.courseId}/subjects/{args.subjectId}/stats") {
      ...SubjectWithStats
    }
  }
  ${fragment}
`;
